<script setup lang="ts">
import { computed } from "vue";
import { getProbeLabel } from "@/shared/utils/probes";
import { withOut, withProbe } from "@/shared/utils/injection";
import ProbeLastValue from "@/features/probe/ProbeLastValue.vue";
import ProbeParams from "@/features/probe/ProbeParams.vue";
import OutModePicker from "@/features/out/OutModePicker.vue";
import IoBanner from "@/features/probe/IoBanner.vue";
import IoFooter from "@/features/probe/IoFooter.vue";

const { out } = withOut();
const { probe } = withProbe();

const label = computed(() => getProbeLabel(probe.value.index));
</script>

<template>
  <div class="probe-view flex flex-col min-h-full">
    <io-banner
      :label="$t(label)"
      :io-type="2"
      :io-index="probe.index"
      :with-chart="!$route.params.poolId?.startsWith('ble:')"
    />

    <div
      class="grid gap-2 lg:max-w-3xl grow lg:grow-0 self-center w-full"
      :class="out ? 'lg:grid-cols-2' : ''"
    >
      <div>
        <probe-last-value class="mb-2" />
        <probe-params :out="out" />
      </div>

      <out-mode-picker v-if="out" />
    </div>

    <io-footer />
  </div>
</template>
